<div [formGroup]="addUserRoleForm" class="card">
  <h4 class=""><strong>Add User Role</strong></h4>
  <hr>
  <div class="grid">
    <div class="col">
        <label><strong>Role Name</strong><span class="required-asterisk">*</span></label>
        <input pInputText formControlName="role_name" style="width:100%"/>
    </div>
    <div class="col">
      <label><strong>Select Menu</strong><span class="required-asterisk">*</span></label>
      <p-multiSelect
            [options]="vendorMenuList"
            formControlName="menu"
            optionLabel="name"
            [style]='{"width":"100%"}'
            placeholder="Select Menu"/>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <label><strong>Select Plant</strong><span class="required-asterisk">*</span></label>
      <p-multiSelect
            [options]="plantList"
            formControlName="plant"
            optionLabel="name1" optionValue="plant__code"
            [style]='{"width":"100%"}'
            placeholder="Select Plant"/>
    </div>
    <div class="col"></div>
  </div>
  <div class="grid">
    <div class="col mt-5" style="width:100%; display:flex; justify-content:center; align-items:center;">
      <p-button label="Submit" (click)="onSubmit()" [disabled]="addUserRoleForm.invalid"></p-button>
    </div>
  </div>

</div>
<p-toast></p-toast>

<!-- Loading Screen -->
<div *ngIf="isLoading" class="loading-overlay">
  <app-loading-screen></app-loading-screen>
</div>


